module.exports = __webpack_public_path__ + "assets/img/00136.a97ea30a.png";